export const TopupSorting = {
  ByFirstName: 'firstName',
  ByAvailableToTopupAmount: 'availableToTopUpAmount'
};
